<!--WxtResource:非结构类资源 - 文档 2020/11/12 18:06:22 YuAng-->

<template>
  <iframe id="iframe_wxt" :src="url" frameborder="0" width="100%" height="100%"></iframe>
</template>
<script>
export default {
  name: 'WxtResource',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    let route = process.env.VUE_APP_URL_WANG_XIAO_TONG_HTTPS + '/ThirdParty/CustomJump?_m=' + encodeURIComponent(encodeURIComponent(location.origin + '/index.html#/source/wxt'))
    route = 'https://sso.zxxk.com/login?service=' + encodeURIComponent('https://auth.zxxk.com/callback?curl=' + encodeURIComponent(route))
    return {
      url: route
    }
  },
  created() {
    this.$root.activeNavigation()
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function (to) {
        if (to.path.indexOf('tabframe') !== -1) {
          this.url = process.env.VUE_APP_URL_WANG_XIAO_TONG_HTTPS + to.query.wxtpath
        }
      }
    }
  }
}
</script>

<style scoped>
#iframe_wxt {
  min-height: calc(100vh - 126px);
}
</style>
